import { z } from 'zod';
import { SocialMediaProvider } from '@anytag/shared-types';

export const RedirectProviderParamsSchema = z.object({
  provider: z.enum(SocialMediaProvider)
});
export type RedirectProviderParamsSchemaType = z.infer<typeof RedirectProviderParamsSchema>;
